module.exports = __webpack_public_path__ + "img/amber.68bbfef6.png";